export default {
  GET_VISIT_DAY_WEEK_MONTH: '/manage/visitDataLog/findUserCountForDayWeekMonth',
  GET_VISIT_COUNT: '/manage/visitDataLog/findUserCountForDate',
  GET_VISIT_COUNT_MONTH: '/manage/visitDataLog/findUserCountByPlatformForMonth',
  GET_VISIT_PLATFORM: '/manage/visitDataLog/findUserCountByPlatform',
  GET_VISIT_MODULE: '/manage/visitDataLog/findVisitModuleUserCountByQuery',
  GET_VISIT_ROLE: '/manage/visitDataLog/findVisitUserRoleUserCountByQuery',
  GET_COUNTRY_DIS: '/management/visitDataLog/country/distribution',
  GET_TYPE_DIS: '/management/visitDataLog/type/distribution',
  GET_DEPARTMENT_DIS: '/management/visitDataLog/department/distribution',
  GET_NEW_USER_DATA: '/management/visitDataLog/register/3RegisterData',
  GET_NEW_USER_CHART_DATA: '/management/visitDataLog/register/platform',
  GET_ACTIVE_USER_DATA: '/management/visitDataLog/active/3ViewData',
  GET_ACTIVE_USER_CHART_DATA: '/management/visitDataLog/active/daily/data',
  GET_ACTIVE_DAY_DATA: '/management/visitDataLog/active/avg/day2Data',
  GET_ACTIVE_DAY_CHART_DATA: '/management/visitDataLog/active/dayCount/Analysis',
  GET_MOSTLY_VISITED_MODULE: '/management/visitDataAnalysis/mostlyVisitedModule',
  GET_HOME_PAGE_CLICK: '/management/visitDataAnalysis/homePageClick',
  GET_SEARCH_PAGE_SEARCH: '/management/visitDataAnalysis/searchPageClick',
  GET_ONLINE_TIME_DATA: '/management/visitDataLog/avg/view/time',
  GET_ONLINE_TIME_CHART_DATA: '/management/visitDataLog/view/times',
  GET_VISITED_PAGE_DATA: '/management/visitDataLog/visit/page/3data',
  GET_VISITED_PAGE_CHART_DATA: '/management/visitDataLog/visit/pages',
  GET_RETENTION_DATA: '/management/visitDataLog/user/retention',
  GET_COMPANY: '/app/user/companies',
  GET_EXPORT_COUNT: '/management/visitDataLog/log/count',
  GET_ACTIVE_COUNT: '/management/visitDataLog/active/count',
  GET_REGISTER_COUNT: '/management/visitDataLog/register/count',
  GET_ACTIVE_AVG_COUNT: '/management/visitDataLog/active/avg/dayCount',
  GET_AVG_ONLINE_TIME: '/management/visitDataLog/avg/view/section/time',
  GET_AVG_VISITED_PAGE: '/management/visitDataLog/visit/page/count'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/userBehavior.js